// ===========================================================================
// Globals
// ===========================================================================

// Module name
export const MODULE_NAME = 'gtm_vars';

export let global_vars = {
    productImpressions: [],
    promotions: [],
    productViews: [],
    uaProductImpressions: [],
    uaPromotions: [],
    uaProductViews: [],
};

// Initialize module
export function initialize() {}
